(function() {
	'use strict';

	/**
	 * Service for managing various dialogs.
	 * @TODO We use the combined history index because that's how we present to user. Should we generate IDs for each transaction?
	 */

	angular
		.module("pwc.services.dialog")
		.service("DialogService", DialogService);

	DialogService.$inject = ['$mdDialog', 'lodash', 'ENV', '$window'];

	function DialogService($mdDialog, lodash, ENV, $window){

		/* jshint validthis: true */
		var self = this;

		self.purchase = purchase;
		self.drink = drink;
		self.sale = sale;
		self.subtract = subtract;
		self.gift = gift;
		self.loss = loss;
		self.versionOutOfDate = versionOutOfDate;

		function purchase(wine, transaction, combinedHistoryIndex, persistOnSave){

			return _openDialog(
				'WinePurchaseDialogController as dialog',
				'templates/dialogs/wine-purchase.html',
				wine,
				transaction,
				combinedHistoryIndex,
				persistOnSave
			);
		}

		function drink(wine, transaction, combinedHistoryIndex, persistOnSave){

			return _openDialog(
				'WineDrinkDialogController as dialog',
				'templates/dialogs/wine-drink.html',
				wine,
				transaction,
				combinedHistoryIndex,
				persistOnSave
			);
		}

		function sale(wine, transaction, combinedHistoryIndex, persistOnSave){

			return _openDialog(
				'WineSaleDialogController as dialog',
				'templates/dialogs/wine-sale.html',
				wine,
				transaction,
				combinedHistoryIndex,
				persistOnSave
			);
		}

		function subtract(wine, persistOnSave){

			return _openDialog(
				'WineSubtractDialogController as dialog',
				'templates/dialogs/wine-subtract.html',
				wine,
				null,
				null,
				persistOnSave
			);
		}

		function gift(wine, transaction, combinedHistoryIndex, persistOnSave){

			return _openDialog(
				'WineGiftDialogController as dialog',
				'templates/dialogs/wine-gift.html',
				wine,
				transaction,
				combinedHistoryIndex,
				persistOnSave
			);
		}

		function loss(wine, transaction, combinedHistoryIndex, persistOnSave){

			return _openDialog(
				'WineLossDialogController as dialog',
				'templates/dialogs/wine-loss.html',
				wine,
				transaction,
				combinedHistoryIndex,
				persistOnSave
			);
		}

		function versionOutOfDate(){

			// only trigger for production!

			if (ENV.name !== 'production'){
				return false;
			}

            $mdDialog.show({
                controller: 'VersionDialogController as dialog',
                templateUrl: 'templates/dialogs/version-out-of-date.html'
			});
		}

		function _openDialog(controller, template, wine, transaction, combinedHistoryIndex, persistOnSave){

			if (lodash.isEmptyOrNull(persistOnSave)){
				persistOnSave = false;
			}

			return $mdDialog.show({
				templateUrl: template,
				controller: controller,
				locals: {
					wine: wine,
					transaction: transaction,
					combinedHistoryIndex: combinedHistoryIndex,
					persistOnSave: persistOnSave
				}
			});

		}
	}

})();
